
































import { Component, Emit, Prop, Vue } from "vue-property-decorator";

import AppBarButtons from "@/components/controls/AppBarButtons.vue";

@Component({
  components: {
    AppBarButtons
  }
})
export default class AppBar extends Vue {
  @Prop({ required: true })
  title!: string;

  @Prop()
  leadName!: string;

  @Prop({ default: true })
  isShowButtons!: boolean;

  @Prop({ default: true })
  isDrawerVisible!: boolean;

  @Prop()
  isCameraOn!: boolean;
  @Prop()
  isBlur!: boolean;

  @Prop()
  isCameraAvailable!: boolean;

  @Prop()
  isMicrophoneOn!: boolean;

  @Prop()
  eventLogo!: string;

  @Prop({ type: Boolean })
  isBlurAvailable!: boolean;

  get leadClass() {
    const isXsScreen = this.$vuetify.breakpoint.name === "xs";
    return {
      title: !isXsScreen,
      "font-weight-bold": isXsScreen
    };
  }

  @Emit()
  toggleCamera(value: boolean) {
    return value;
  }

  @Emit()
  toggleMicrophone(value: boolean) {
    return value;
  }
  @Emit()
  toggleBlur(value: boolean) {
    return value;
  }
}
